
export const SEARCH_CONSTANTS = {
  MIN_SEARCH_LENGTH: 3,
  DEBOUNCE_TIME: 500, // Standardized to 500ms for auto-search
  POPULAR_LIMIT: 20,
  NO_RESULTS_TIMEOUT: 2000,
  MOVIE_SEARCH_LIMIT: 5,
  UNIFIED_MOVIE_LIMIT: 30,
  // Add keyboard navigation keys
  KEYBOARD_NAV_KEYS: ['ArrowDown', 'ArrowUp', 'Enter', 'Escape'],
  // Add cache duration constants
  CACHE_DURATION: {
    SEARCH: 1000 * 60 * 5, // 5 minutes
    SEARCH_CACHE: 1000 * 60 * 30, // 30 minutes
    POPULAR: 1000 * 60 * 60 // 1 hour
  }
};
